(function () {
  if (!window.__pplMegaMobileBackInit) {
    window.__pplMegaMobileBackInit = true;

    document.addEventListener('click', function (event) {
      var backBtn = event.target.closest('[data-mm-back]');
      if (!backBtn) return;

      var details = backBtn.closest('details');
      if (!details) return;

      details.removeAttribute('open');
    });
  }

  if (!window.__pplMegaDesktopTopLinkInit) {
    window.__pplMegaDesktopTopLinkInit = true;

    document.addEventListener('click', function (event) {
      var topLink = event.target.closest('[data-mm-top-link]');
      if (!topLink) return;

      var summary = topLink.closest('summary');
      if (!summary) return;

      event.stopPropagation();
    }, true);

    document.addEventListener('mousedown', function (event) {
      var topLink = event.target.closest('[data-mm-top-link]');
      if (!topLink) return;

      var summary = topLink.closest('summary');
      if (!summary) return;

      event.stopPropagation();
    }, true);

    document.addEventListener('keydown', function (event) {
      var topLink = event.target.closest('[data-mm-top-link]');
      if (!topLink) return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.stopPropagation();
      }
    }, true);
  }
})();
